import { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { useWeb3 } from '@/hooks/use-web3';
import { ShortenAddr } from '@/lib/Shorten';
import ConnectInfo from '@/component/ConnectWallet/ConnectInfo';
import { LOCAL_SESSION, LOCAL_SESSION_TIME } from '@/lib/common/name-space';
import { localGetStorage, localSetStorage } from '@/lib/storage';
import { useLocation, useNavigate } from 'react-router-dom';
import CommonTop from '../pools/CommonTop';
import PoolsOverview from '../pools/card/PoolsOverview';

export default function ConnectWallet() {
  const [isInfo, setIsInfo] = useState(false);
  const [address, setAddress] = useState('');
  const { web3authCall } = useWeb3();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (address) {
      return;
    }
    (async () => {
      if (web3authCall?.connected()) {
        const addr = await web3authCall.getAddress();
        setAddress(addr);
      }
    })();
    return () => {};
  }, [web3authCall, address]);

  const handleClose = (value: boolean) => {
    setIsInfo(value);
  };
  const handleConnect = async () => {
    const re = await web3authCall?.getWeb3auth().connect();
    if (re) {
      const userAccount: string[] = await web3authCall?.getRpc().getAccounts()!;
      console.log(userAccount[0]);
      if (userAccount[0]) {
        const userInfo = await web3authCall?.getUserInfo();
        console.log(userInfo?.typeOfLogin);

        const re = localGetStorage(LOCAL_SESSION);
        if (!re) {
          setSession();
          changeLoginType();
        }
        // navigate('/pools');
        const path = location.pathname;
        if (path === '/pools') {
          window.location.reload();
        } else {
          navigate('/pools');
        }
      }
    }
  };
  const setSession = () => {
    const now = new Date();
    const payload = {
      key: LOCAL_SESSION,
      value: {
        sessionTime: now.getTime() + LOCAL_SESSION_TIME,
      },
    };
    localSetStorage(payload);
  };
  const changeLoginType = async () => {
    const res = localGetStorage('snsAddress');
    if (!res) {
      return;
    }
    const re = await web3authCall!.getUserInfo();
    const loginType = re.typeOfLogin ?? 'external';
    const payload = {
      key: 'snsAddress',
      value: {
        ...res,
        typeOfLogin: loginType,
      },
    };
    localSetStorage(payload);
  };

  return (
    <>
      <CommonTop title="Pools" subtitle="Pools Of Real-World Assets">
        <Box
          sx={{
            maxWidth: '1680px',
            padding: '16px 24px',
            display: 'flex',
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
            gap: {
              xs: '10px',
              sm: '20px',
            },
          }}
        >
          {/* <PoolsOverview title="Total Staked" content="100,000 aaaaaa USD" />
          <PoolsOverview title="Total Achievment Rate" content="83.42 aaaaa%" />
          <PoolsOverview title="Total Number Of Wallets" content="60 aaaaa" /> */}
        </Box>
      </CommonTop>

      {/* {isInfo && <ConnectInfo open={isInfo} onClose={handleClose} />} */}
    </>
  );
}
